


































import changeCommerceToCompany from './../forms/changeCommerceToCompanyForm.vue';
import updateTipPercent from './../forms/updateTipPercent.vue';
import updateStatus from './../forms/updateStatus.vue';
import updateLiquidationModel from '@/components/commerce/Partners/modals/updateLiquidationModel.vue';
import company_commerce from '@/store/types/company_commerce';
import { mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'ConfigCompanyCommerceModal',
  components: {
    changeCommerceToCompany,
    updateLiquidationModel,
    updateTipPercent,
    updateStatus,
  },
  props: {
    viewModal: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      singleCompanyCommerce: `companyCommerceModule/${company_commerce.getters.GET_SINGLE_COMPANY_COMMERCE}`,
    }),
    syncedViewModal: {
      get(): boolean {
        return this.viewModal;
      },
      set(value: boolean): void {
        this.$emit('update:viewModal', value);
      },
    },
    kindSlugValidator(): boolean {
      return this.singleCompanyCommerce.liquidation_kind_slug === 'agregador';
    },
  },
  methods: {
    success(): void {
      this.syncedViewModal = false;
      this.$emit('success');
    },
  },
});
